import { useEffect } from 'react'

import { trackByIdQuery, trackToggleArchive } from '@/entities/tracks'
import { ROUTES } from '@/shared/config'
import {
  ContentWrapper,
  ErrorResult,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { TrackForm } from '@/widgets/TrackForm'
import { Breadcrumb, Button, Layout, Space } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useParams } from 'react-router-dom'

export const TrackEditPage = () => {
  const { id } = useParams<{ id: string }>()
  const { start, data, pending, error } = useUnit(trackByIdQuery)
  const reset = useUnit(trackByIdQuery.reset)

  const toggleArchive = useUnit(trackToggleArchive)

  useEffect(() => {
    if (id) {
      start({ id })
    }
    return () => {
      reset()
    }
  }, [id, start, reset])

  return (
    <Layout>
      <HidingSpin spinning={pending || (!data && !error)}>
        {data && !error ? (
          <>
            <HeaderContent
              breadcrumbSlot={
                <Breadcrumb
                  items={[
                    { title: 'Контент' },
                    { title: <Link to={ROUTES.AUDIO.ROOT}>Аудиофайлы</Link> },
                    { title: 'Редактирование записи' },
                  ]}
                />
              }
              title={data.name}
              description="Раздел позволяет редактировать информацию о треке"
              buttonSlot={
                <Space size="middle">
                  <Button
                    variant="solid"
                    style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.06)',
                      borderColor: 'rgba(0, 0, 0, 0.06)',
                    }}
                    loading={toggleArchive.pending}
                    onClick={() =>
                      void toggleArchive.start({
                        id: data.id,
                        data: { isArchive: !data.isArchive },
                      })
                    }
                  >
                    {data.isArchive ? 'Раза' : 'А'}рхивировать запись
                  </Button>
                </Space>
              }
            />

            <ContentWrapper>
              <TrackForm />
            </ContentWrapper>
          </>
        ) : (
          <ContentWrapper>
            <ErrorResult
              error={error}
              notFoundConfig={{
                subTitle: 'Данного трека не существует.',
                navigateTo: ROUTES.AUDIO.ROOT,
              }}
            />
          </ContentWrapper>
        )}
      </HidingSpin>
    </Layout>
  )
}
